import renderModule from "./render/module";

export default function load(container) {
    container.load(renderModule);
}
//# sourceMappingURL=modules.js.map
